import React, { useEffect, useState, useRef } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Banner.css';
//import bannerVideo from '../../Assets/Vedio/beatsfitnesstraining.mp4';
import BeatsEventPicture from '../../Assets/images/Banner/websitecover2.jpg';

const Banner = () => {
  const [isTouch, setIsTouch] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const bannerRef = useRef(null);
  const timeoutRef = useRef(null);

  const slideDurations = [20000, 10000]; // 20s for image, 10s for video

  useEffect(() => {
    const checkTouch = () => {
      setIsTouch(window.innerWidth <= 1024);
    };
    checkTouch();
    window.addEventListener('resize', checkTouch);
    return () => window.removeEventListener('resize', checkTouch);
  }, []);

  useEffect(() => {
    const adjustHeight = () => {
      if (bannerRef.current) {
        const activeSlide = bannerRef.current.querySelector(
          '.carousel .slide.selected'
        );
        if (activeSlide) {
          bannerRef.current.style.height = `${activeSlide.offsetHeight}px`;
        }
      }
    };

    adjustHeight();
    const timeout = setTimeout(adjustHeight, 300);
    window.addEventListener('resize', adjustHeight);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('resize', adjustHeight);
    };
  }, [currentSlide]);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % 2); // toggle between 0 and 1
    }, slideDurations[currentSlide]);

    return () => clearTimeout(timeoutRef.current);
  }, [currentSlide]);

  const isMobile = window.innerWidth <= 768;

  return (
    <section id="home-section" className="banner-section" ref={bannerRef}>
      <Carousel
        showArrows
        autoPlay={false}
        infiniteLoop
        transitionTime={1000}
        showThumbs={false}
        showStatus={false}
        stopOnHover={false}
        swipeable={isTouch}
        emulateTouch={isTouch}
        dynamicHeight={true}
        selectedItem={currentSlide}
        onChange={(index) => setCurrentSlide(index)}
      >
        {/* ✅ Image Slide wrapped in a clickable <a> */}
        <div className="carousel-slide">
          <a>
            <img
              src={BeatsEventPicture}
              alt="Event"
              loading="lazy"
              style={{
                width: '100%',
                height: isMobile ? 'auto' : '100%',
                objectFit: 'cover',
                cursor: 'pointer'
              }}
            />
          </a>
        </div>

        {/* Video Slide */}
        {/* <div className="carousel-slide" style={{ position: 'relative' }}>
          <div
            style={{
              position: 'absolute',
              top: isMobile ? '30px' : '60px',
              left: isMobile ? '15px' : '25px',
              zIndex: 100,
              color: 'white',
              fontSize: isMobile ? '18px' : '25px',
              fontWeight: 'bold'
            }}
          >
            <p
              style={{
                fontSize: isMobile ? '35px' : '70px',
                color: 'white',
                lineHeight: isMobile ? '40px' : '80px',
                fontFamily: 'Jost'
              }}
            >
              Elevate Your Fitness. Conquer Your Limits.
            </p>
          </div>
          <video
            autoPlay
            loop
            playsInline
            muted
            src={bannerVideo}
            onLoadedMetadata={(e) => {
              bannerRef.current.style.height = `${e.target.offsetHeight}px`;
            }}
            style={{
              width: '100%',
              height: isMobile ? 'auto' : '100vh',
              objectFit: 'cover'
            }}
          ></video>
        </div> */}
      </Carousel>
    </section>
  );
};

export default Banner;
